// import React, { useEffect, useState } from 'react';
// import { useParams, Link } from 'react-router-dom';
// import axios from 'axios';
// import Loader from '../../components/common/Loader';
// import UserHeader from '../../components/common/UserHeader';
// import banner from '../../assets/headerBanner.png';
// import { FaCalendarAlt, FaThumbsUp, FaRegCommentDots, FaShareAlt } from 'react-icons/fa';
// import { FaRegFolderOpen } from 'react-icons/fa6';

// const ArticlesDetails = () => {
//   const { id } = useParams();
//   const [article, setArticle] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const [commentName, setCommentName] = useState('');
//   const [commentText, setCommentText] = useState('');
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   useEffect(() => {
//     fetchArticleDetails();
//   }, [id]);

//   const fetchArticleDetails = async () => {
//     try {
//       setIsLoading(true);
//       const res = await axios.get(`${process.env.REACT_APP_API_URL}/articles/get-articles-by-id/${id}`);
//       setArticle(res.data);
//       setIsLoading(false);
//     } catch (error) {
//       console.error('Error fetching article details:', error);
//       setError('Failed to load article details. Please try again later.');
//       setIsLoading(false);
//     }
//   };

//   // ✅ Like handler
//   const handleLike = async () => {
//     try {
//       await axios.post(`${process.env.REACT_APP_API_URL}/articles/${id}/like`);
//       fetchArticleDetails();
//     } catch (error) {
//       console.error('Like failed:', error);
//     }
//   };

//   // ✅ Share handler
//   const handleShare = async () => {
//     try {
//       await axios.post(`${process.env.REACT_APP_API_URL}/articles/${id}/share`);
//       fetchArticleDetails();

//       // Share using Web Share API (for mobile)
//       if (navigator.share) {
//         navigator.share({
//           title: article.title,
//           text: article.title,
//           url: window.location.href,
//         });
//       } else {
//         alert('Link copied to clipboard!');
//         navigator.clipboard.writeText(window.location.href);
//       }
//     } catch (error) {
//       console.error('Share failed:', error);
//     }
//   };

//   // ✅ Add comment handler
//   const handleAddComment = async (e) => {
//     e.preventDefault();
//     if (!commentName.trim() || !commentText.trim()) {
//       alert('Please enter your name and comment.');
//       return;
//     }

//     try {
//       setIsSubmitting(true);
//       await axios.post(`${process.env.REACT_APP_API_URL}/articles/${id}/comment`, {
//         name: commentName,
//         text: commentText,
//       });
//       setCommentName('');
//       setCommentText('');
//       fetchArticleDetails();
//     } catch (error) {
//       console.error('Comment failed:', error);
//       alert('Failed to add comment.');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const formatDate = (dateString) => {
//     const options = { year: 'numeric', month: 'long', day: 'numeric' };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };

//   return (
//     <React.Fragment>
//       <UserHeader
//         headerImg={banner}
//         pageName="Article Details"
//         mainText="Home"
//       />

//       {isLoading ? (
//         <div className="py-10 px-4 md:px-10">
//           <div className="rounded-md flex tracking-wider font-semibold justify-center items-center border border-slate-400 p-4">
//             <Loader /> <span className="ml-2">Please Wait...</span>
//           </div>
//         </div>
//       ) : error ? (
//         <div className="py-10 px-4 md:px-10 text-red-600 border border-red-400 rounded-md p-4 text-center">
//           {error}
//         </div>
//       ) : (
//         <div className="px-4 md:px-10 py-10">
//           <div className="bg-white shadow-lg rounded-2xl overflow-hidden max-w-5xl mx-auto">
//             {/* Header Image */}
//             <div className="w-full h-[500px] bg-gray-200 flex items-center justify-center overflow-hidden">
//               <img
//                 src={article?.images?.[0] || 'https://via.placeholder.com/800x500'}
//                 alt="Article"
//                 className="w-full h-full object-cover"
//               />
//             </div>

//             {/* Content */}
//             <div className="p-6 md:p-10">
//               <h1 className="text-3xl md:text-4xl font-bold text-[#1C1C25] mb-4">
//                 {article.title}
//               </h1>

//               <div className="flex flex-wrap gap-4 text-gray-600 text-sm mb-6">
//                 <div className="flex items-center gap-2">
//                   <FaCalendarAlt className="text-[#2F9BD6]" />
//                   <span>{formatDate(article.createdAt)}</span>
//                 </div>
//                 <div className="flex items-center gap-2">
//                   <FaRegFolderOpen className="text-[#2F9BD6]" />
//                   <span>{article.author}</span>
//                 </div>
//               </div>

//               <div
//                 className="text-gray-700 leading-relaxed text-justify text-lg md:text-xl border-l-4 border-[#2F9BD6] pl-4 mb-8"
//                 dangerouslySetInnerHTML={{
//                   __html:
//                     Array.isArray(article.description)
//                       ? article.description[0] || "No description available."
//                       : article.description || "No description available.",
//                 }}
//               />

//               {/* Like / Share / Comment buttons */}
//               <div className="flex justify-between items-center py-4 border-t border-b mb-8 text-gray-700">
//                 <button
//                   onClick={handleLike}
//                   className="flex items-center gap-2 text-blue-600 hover:text-blue-800 font-medium"
//                 >
//                   <FaThumbsUp /> {article.likes || 0} Likes
//                 </button>

//                 <button
//                   onClick={handleShare}
//                   className="flex items-center gap-2 text-purple-600 hover:text-purple-800 font-medium"
//                 >
//                   <FaShareAlt /> {article.shares || 0} Shares
//                 </button>

//                 <div className="flex items-center gap-2 text-green-600 font-medium">
//                   <FaRegCommentDots /> {article.comments?.length || 0} Comments
//                 </div>
//               </div>

//               {/* 💬 Comment Form */}
//               <div className="bg-gray-50 p-6 rounded-xl border">
//                 <h2 className="text-2xl font-semibold mb-4 text-[#1C1C25]">
//                   Leave a Comment
//                 </h2>
//                 <form onSubmit={handleAddComment} className="flex flex-col gap-4">
//                   <input
//                     type="text"
//                     value={commentName}
//                     onChange={(e) => setCommentName(e.target.value)}
//                     placeholder="Enter your name"
//                     className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
//                   />
//                   <textarea
//                     value={commentText}
//                     onChange={(e) => setCommentText(e.target.value)}
//                     placeholder="Write your comment..."
//                     className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
//                     rows="4"
//                   ></textarea>
//                   <button
//                     type="submit"
//                     disabled={isSubmitting}
//                     className="bg-gradient-to-r from-[#FF3131] to-[#ff9301] text-white py-2 rounded-lg font-semibold hover:opacity-90 transition"
//                   >
//                     {isSubmitting ? 'Posting...' : 'Post Comment'}
//                   </button>
//                 </form>
//               </div>

//               {/* 🗨️ Comments Section */}
//               <div className="mt-8">
//                 <h3 className="text-2xl font-semibold mb-4 text-[#1C1C25]">
//                   Comments
//                 </h3>
//                 {article.comments && article.comments.length > 0 ? (
//                   <div className="space-y-4">
//                     {article.comments.map((cmt) => (
//                       <div
//                         key={cmt._id}
//                         className="bg-white border rounded-lg p-4 shadow-sm"
//                       >
//                         <p className="font-semibold text-[#2F9BD6]">{cmt.name}</p>
//                         <p className="text-gray-700">{cmt.text}</p>
//                       </div>
//                     ))}
//                   </div>
//                 ) : (
//                   <p className="text-gray-500 italic">No comments yet. Be the first to comment!</p>
//                 )}
//               </div>

//               <Link
//                 to="/"
//                 className="inline-block mt-10 text-[#2F9BD6] hover:text-[#1C1C25] font-semibold transition"
//               >
//                 ← Back to Articles
//               </Link>
//             </div>
//           </div>
//         </div>
//       )}
//     </React.Fragment>
//   );
// };

// export default ArticlesDetails;



import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import SEO from '../../components/common/SEO';
import Loader from '../../components/common/Loader';
import UserHeader from '../../components/common/UserHeader';
import banner from '../../assets/headerBanner.png';
import { FaCalendarAlt, FaThumbsUp, FaRegCommentDots, FaShareAlt } from 'react-icons/fa';
import { FaRegFolderOpen } from 'react-icons/fa6';
// import { format } from 'date-fns';

const UserarticleDetails = () => {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [commentName, setCommentName] = useState('');
  const [commentText, setCommentText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [liked, setLiked] = useState(false);

  useEffect(() => {
    fetchArticleDetails();
    // Check if user already liked
    const likedKey = `liked_article_${slug}`;
    setLiked(localStorage.getItem(likedKey) === 'true');
  }, [slug]);

  const fetchArticleDetails = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/articles/get-articles-by-slug/${slug}`
      );
      setArticle(res.data);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching article details:', error);
      setError('Failed to load article details. Please try again later.');
      setIsLoading(false);
    }
  };

  const handleLike = async () => {
    const likedKey = `liked_article_${slug}`;
    if (localStorage.getItem(likedKey)) {
      alert('You already liked this article!');
      return;
    }

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/articles/${article._id}/like`);
      setArticle({ ...article, likes: (article.likes || 0) + 1 });
      localStorage.setItem(likedKey, 'true');
      setLiked(true);
    } catch (error) {
      console.error('Like failed:', error);
    }
  };

  const handleShare = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/articles/${article._id}/share`);
      setArticle({ ...article, shares: (article.shares || 0) + 1 });

      const shareUrl = `${window.location.origin}/article/${article.slug}`;
      if (navigator.share) {
        navigator.share({
          title: article.metaTitle || article.title,
          text: article.metaDescription || article.title,
          url: shareUrl,
        });
      } else {
        navigator.clipboard.writeText(shareUrl);
        alert('Link copied to clipboard!');
      }
    } catch (error) {
      console.error('Share failed:', error);
    }
  };

  const handleAddComment = async (e) => {
    e.preventDefault();
    if (!commentName.trim() || !commentText.trim()) {
      alert('Please enter your name and comment.');
      return;
    }

    try {
      setIsSubmitting(true);
      await axios.post(`${process.env.REACT_APP_API_URL}/articles/${article._id}/comment`, {
        name: commentName,
        text: commentText,
      });
      // Refetch to get updated comments
      await fetchArticleDetails();
      setCommentName('');
      setCommentText('');
    } catch (error) {
      console.error('Comment failed:', error);
      alert('Failed to add comment.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Unknown Date';
    try {
      return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    } catch {
      return 'Unknown Date';
    }
  };

  if (isLoading) {
    return (
      <>
        <UserHeader headerImg={banner} pageName="Article Details" mainText="Home" />
        <div className="py-10 px-4 md:px-10">
          <div className="rounded-md flex tracking-wider font-semibold justify-center items-center border border-slate-400 p-4">
            <Loader /> <span className="ml-2">Please Wait...</span>
          </div>
        </div>
      </>
    );
  }

  if (error || !article) {
    return (
      <>
        <UserHeader headerImg={banner} pageName="Article Details" mainText="Home" />
        <div className="py-10 px-4 md:px-10">
          <div className="rounded-md flex tracking-wider font-semibold justify-center items-center border border-red-400 p-4 text-red-600">
            {error || 'Article not found.'}
          </div>
        </div>
      </>
    );
  }

  return (
    <React.Fragment>
      {/* SEO Meta Tags for Article */}
      <SEO 
        title={article.metaTitle || article.title}
        description={article.metaDescription || article.title}
        keywords={article.keywords || ''}
        canonical={article.canonical || `https://www.bbsrservices.co.in/article/${article.slug}`}
        image={article.images?.[0]}
        type="article"
        publishedTime={article.createdAt}
        author={article.author}
      />

      <UserHeader headerImg={banner} pageName="Article Details" mainText="Home" />

      <div className="px-4 md:px-10 py-10 bg-gray-50 min-h-screen">
        <div className="bg-white shadow-lg rounded-2xl overflow-hidden max-w-5xl mx-auto">
          {/* Header Image */}
          <div className="w-full h-[400px] md:h-[500px] bg-gray-200 flex items-center justify-center overflow-hidden">
            <img
              src={article?.images?.[0] || 'https://via.placeholder.com/800x500/2F9BD6/FFFFFF?text=Article'}
              alt={article.title}
              className="w-full h-full object-cover"
            />
          </div>

          {/* Content */}
          <div className="p-6 md:p-10">
            {/* URL Display */}
            <div className="mb-4 text-sm text-gray-500 bg-gray-50 px-3 py-1 rounded-lg inline-block">
              <span className="font-medium">🔗 URL:</span> /article/{article.slug}
            </div>

            <h1 className="text-3xl md:text-4xl font-bold text-[#1C1C25] mb-4">
              {article.title}
            </h1>

            <div className="flex flex-wrap gap-4 text-gray-600 text-sm mb-6">
              <div className="flex items-center gap-2">
                <FaCalendarAlt className="text-[#2F9BD6]" />
                <span>{formatDate(article.createdAt)}</span>
              </div>
              <div className="flex items-center gap-2">
                <FaRegFolderOpen className="text-[#2F9BD6]" />
                <span>{article.author}</span>
              </div>
            </div>

            {/* Article Description */}
            <div
              className="text-gray-700 leading-relaxed text-justify text-base md:text-lg"
              dangerouslySetInnerHTML={{
                __html: article.description || 'No description available.'
              }}
            />

            {/* Like / Share / Comment buttons */}
            <div className="flex flex-wrap justify-between items-center py-4 border-t border-b mb-8 mt-8 text-gray-700 gap-4">
              <button
                onClick={handleLike}
                className={`flex items-center gap-2 font-medium transition-colors ${liked ? 'text-red-500' : 'text-blue-600 hover:text-blue-800'}`}
                disabled={liked}
              >
                <FaThumbsUp className={liked ? 'animate-pulse' : ''} /> 
                {article.likes || 0} {article.likes === 1 ? 'Like' : 'Likes'}
              </button>

              <button
                onClick={handleShare}
                className="flex items-center gap-2 text-purple-600 hover:text-purple-800 font-medium"
              >
                <FaShareAlt /> {article.shares || 0} Shares
              </button>

              <div className="flex items-center gap-2 text-green-600 font-medium">
                <FaRegCommentDots /> {article.comments?.length || 0} Comments
              </div>
            </div>

            {/* 💬 Comment Form */}
            <div className="bg-gray-50 p-6 rounded-xl border">
              <h2 className="text-2xl font-semibold mb-4 text-[#1C1C25]">
                Leave a Comment
              </h2>
              <form onSubmit={handleAddComment} className="flex flex-col gap-4">
                <input
                  type="text"
                  value={commentName}
                  onChange={(e) => setCommentName(e.target.value)}
                  placeholder="Enter your name"
                  className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
                <textarea
                  value={commentText}
                  onChange={(e) => setCommentText(e.target.value)}
                  placeholder="Write your comment..."
                  className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  rows="4"
                ></textarea>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="bg-gradient-to-r from-[#FF3131] to-[#ff9301] text-white py-2 rounded-lg font-semibold hover:opacity-90 transition"
                >
                  {isSubmitting ? 'Posting...' : 'Post Comment'}
                </button>
              </form>
            </div>

            {/* 🗨️ Comments Section */}
            <div className="mt-8">
              <h3 className="text-2xl font-semibold mb-4 text-[#1C1C25]">
                Comments ({article.comments?.length || 0})
              </h3>
              {article.comments && article.comments.length > 0 ? (
                <div className="space-y-4">
                  {article.comments.map((cmt) => (
                    <div
                      key={cmt._id}
                      className="bg-white border rounded-lg p-4 shadow-sm"
                    >
                      <p className="font-semibold text-[#2F9BD6]">{cmt.name || 'Anonymous'}</p>
                      <p className="text-gray-700 mt-1">{cmt.text}</p>
                      <p className="text-xs text-gray-400 mt-1">
                        {cmt.date ? formatDate(cmt.date) : ''}
                      </p>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-gray-500 italic">No comments yet. Be the first to comment!</p>
              )}
            </div>

            <Link
              to="/all-article"
              className="inline-block mt-10 text-[#2F9BD6] hover:text-[#1C1C25] font-semibold transition"
            >
              ← Back to Articles
            </Link>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default UserarticleDetails;